import React, { useState, useEffect } from "react";

import { useSelector, connect } from "react-redux";
import Select from "react-select";
import { Button, InputGroup, Label } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";

const StatisticFiltersUser = props => {
  const token = useSelector(state => state.user.token);
  const activeRole = useSelector(state => state.general.active_roles);

  const [hierarchy, setHierarchy] = useState([]);
  const [loading, setLoading] = useState(true);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [userId, setUserId] = useState(0);

  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  useEffect(() => {
    let params = {
      activity_id: props.activityId,
      users: true
    };

    let roles = {
      group_id: props.user.user_roles[0].group_id ?? null,
      region_id: props.user.user_roles[0].region_id ?? null,
      school_id: props.user.user_roles[0].school_id ?? null
    };

    if (roles.school_id) {
      params.school_id = roles.school_id;
    } else if (roles.region_id) {
      params.region_id = roles.region_id;
    } else if (roles.group_id) {
      params.group_id = roles.group_id;
    }

    axios
      .get(`${URL.api}activity/activity/getHierarchyAllocations`, {
        params,
        headers: { authorization: `Bearer ${token}` }
      })
      .then(res => {
        let group = 0;
        let region = 0;
        let school = 0;
        let room = 0;
        let user = 0;
        if (props.infoUser) {
          group = props.infoUser.group;
          region = props.infoUser.region;
          school = props.infoUser.school;
          room = props.infoUser.room;
          user = props.infoUser.user;
        } else if (props.emptySelection) {
          /* Começa com os campos vazios: só ficam preenchidos os níveis que o
             papel do usuário já fixa (e que, por isso, aparecem desabilitados).
             Um adm de grupo abre a tela com o grupo dele selecionado e o resto
             em branco. */
          group = activeRole.group_id || 0;
          region = activeRole.region_id || 0;
          school = activeRole.school_id || 0;
        } else {
          group =
            res.data.data.length > 0
              ? activeRole.group_id || res.data.data[0].id
              : 0;
          region =
            res.data.data.length > 0
              ? activeRole.region_id || res.data.data[0].regions[0].id
              : 0;
          school =
            res.data.data.length > 0
              ? activeRole.school_id ||
                res.data.data[0].regions[0].schools[0].id
              : 0;
          room =
            res.data.data.length > 0
              ? res.data.data[0].regions[0].schools[0].rooms[0].id
              : 0;
        }

        setHierarchy(res.data.data);
        setGroupId(group);
        setRegionId(region);
        setSchoolId(school);
        setRoomId(room);
        setLoading(false);
      });
  }, []);

  const changeGroup = id => {
    setGroupId(id);
    setRegionId(0);
    setSchoolId(0);
    setRoomId(0);
    setUserId(0);
  };

  const changeRegion = id => {
    setRegionId(id);
    setSchoolId(0);
    setRoomId(0);
    setUserId(0);
  };

  const changeSchool = id => {
    setSchoolId(id);
    setRoomId(0);
    setUserId(0);
  };

  const changeRoom = id => {
    setRoomId(id);
    setUserId(0);
  };

  const changeUser = id => {
    setUserId(id);
  };

  const onClick = () => {
    props.onChange({
      hierarchy,
      groupId,
      regionId,
      schoolId,
      roomId,
      userId
    });
  };

  /* Dispara o Filtrar sozinho a cada valor novo de `autoSubmit` — usado pelas
     telas que refazem a busca ao trocar de avaliação, sem obrigar o usuário a
     clicar. A seleção atual dos campos é preservada; só espera a hierarquia
     terminar de carregar. Sem o prop, nada muda: o filtro só busca no clique. */
  useEffect(() => {
    if (props.autoSubmit === undefined || loading || hierarchy.length === 0) {
      return;
    }

    onClick();
  }, [props.autoSubmit, loading]);

  useEffect(() => {
    !props.hideUser && findStudentsRoom();
  }, [roomId]);

  const findStudentsRoom = () => {
    setUsers([]);
    setLoadingUsers(true);
    axios
      .get(`${URL.api}activity/activity/getHierarchyAllocations`, {
        params: {
          activity_id: props.activityId,
          users: true,
          room_id: roomId,
          users_with_applications: true
        },
        headers: { authorization: `Bearer ${token}` }
      })
      .then(res => {
        setUsers(res.data.data[0].regions[0].schools[0].rooms[0].users);
      })
      .catch(err => {})
      .finally(() => {
        setLoadingUsers(false);
      });
  };

  const groups = hierarchy;
  const regions = hierarchy.find(item => item.id === groupId)?.regions || [];
  const schools = regions.find(item => item.id === regionId)?.schools || [];
  const rooms = schools.find(item => item.id === schoolId)?.rooms || [];

  /* Com emptySelection, campo em branco quer dizer "sem recorte neste nível" —
     ou seja, todos. O placeholder diz isso, em vez de repetir o nome do campo. */
  const placeholderFor = (label, all = "Todas") =>
    props.emptySelection ? all : label;

  if (hierarchy.length === 0 && !loading) {
    return (
      <div className="d-flex align-items-center justify-content-center text-muted mb-4">
        A avaliação ainda não foi alocada
      </div>
    );
  }

  return (
    <div className="row align-items-end mb-4">
      {!props.hideGroup && (
        <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Grupo</Label>
          </div>
          <InputGroup className="w-100">
            <Select
              className="w-100"
              value={groups.find(item => item.id === groupId)}
              placeholder={placeholderFor("Grupo", "Todos")}
              onChange={e => changeGroup(parseInt(e.id))}
              isDisabled={!!activeRole.group_id}
              options={groups.sort((a, b) => a.name?.localeCompare(b.name))}
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              isLoading={loading}
              loadingMessage={() => "Carregando..."}
            />
          </InputGroup>
        </div>
      )}
      {!props.hideRegion && (
        <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Região</Label>
          </div>
          <InputGroup className="w-100">
            <Select
              className="w-100"
              key={groupId}
              value={regions.find(item => item.id === regionId)}
              placeholder={placeholderFor("Região")}
              onChange={e => changeRegion(e ? parseInt(e.id) : 0)}
              isDisabled={!!activeRole.region_id}
              options={regions.sort((a, b) => a.name?.localeCompare(b.name))}
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              isLoading={loading}
              loadingMessage={() => "Carregando..."}
              isClearable
            />
          </InputGroup>
        </div>
      )}
      {!props.hideSchool && (
        <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Escola</Label>
          </div>
          <InputGroup className="w-100">
            <Select
              className="w-100"
              key={regionId}
              value={schools.find(item => item.id === schoolId)}
              placeholder={placeholderFor("Escola")}
              onChange={e => changeSchool(e ? parseInt(e.id) : 0)}
              isDisabled={!!activeRole.school_id}
              options={schools.sort((a, b) => a.name?.localeCompare(b.name))}
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              isLoading={loading}
              loadingMessage={() => "Carregando..."}
              isClearable
            />
          </InputGroup>
        </div>
      )}
      {!props.hideRoom && (
        <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Turma</Label>
          </div>
          <InputGroup className="w-100">
            <Select
              className="w-100"
              key={schoolId}
              value={rooms.find(item => item.id === roomId)}
              placeholder={placeholderFor("Turma")}
              onChange={e => changeRoom(e ? parseInt(e.id) : 0)}
              options={rooms.sort((a, b) => a.name?.localeCompare(b.name))}
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              isLoading={loading}
              loadingMessage={() => "Carregando..."}
              isClearable
            />
          </InputGroup>
        </div>
      )}
      {!props.hideUser && (
        <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
          <div className="w-100 text-ellipsis">
            <Label className="d-block w-100 text-ellipsis">Estudante</Label>
          </div>
          <InputGroup className="w-100">
            <Select
              className="w-100"
              key={roomId}
              value={users.find(item => item.id === userId)}
              placeholder="Estudante"
              onChange={e => changeUser(e ? parseInt(e.id) : 0)}
              options={users.sort((a, b) => a.name?.localeCompare(b.name))}
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              isLoading={loadingUsers}
              loadingMessage={() => "Carregando..."}
              isClearable
            />
          </InputGroup>
        </div>
      )}
      <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-0">
        <Button
          color="primary"
          className="d-flex align-items-center"
          onClick={onClick}
        >
          <i className="fa fa-filter mr-2"></i>Filtrar
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatisticFiltersUser);
